import moment from "moment-timezone";

/**
 * Maps a recently-changed PMX catalog API row for Home display.
 * @param {Object} item - Raw API row
 * @returns {Object} Row with formattedModifiedAt for rendering
 */
export function formatPmxCatalogForDisplay(item) {
  const formattedModifiedAt = item?.modified_at
    ? moment(moment.utc(item.modified_at).toDate())
        .tz(moment.tz.guess())
        .format("DD-MMM-YYYY, h:mm:ss A z")
    : "";

  return {
    ...item,
    formattedModifiedAt,
  };
}

/**
 * @param {Array} items - Raw API rows
 * @returns {Array} Display-ready catalog rows
 */
export function formatPmxCatalogsForDisplay(items) {
  if (!Array.isArray(items)) return [];
  return items.map(formatPmxCatalogForDisplay);
}
